/**
 * * Модель запроса пагинации
 */
export class PaginationRequestModel {
  /**Сколько элементов пропустить */
  Skip?: number;
  /**Сколько элементов получить */
  Take?: number;

  constructor(obj?: Partial<PaginationRequestModel>) {
    Object.assign(this, obj);
  }
}
